import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { ApiPropertyValuationValuationBlockFactorAdjustmentsConstants } from "../../../../../../../shared/constants/api-constants/api-property-valuation-valuation-block-factor-adjustments.constants";
let AddValuationBlockFactorAdjustmentsService = class AddValuationBlockFactorAdjustmentsService {
    httpClient;
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getPropertyValuationValuationBlockFactorAdjustments(params) {
        return this.httpClient.get(ApiPropertyValuationValuationBlockFactorAdjustmentsConstants.URL, { params })
            .pipe(map(response => {
            return response.value;
        }));
    }
    addPropertyValuationValuationBlockFactorAdjustment(params) {
        return this.httpClient.post(`${ApiPropertyValuationValuationBlockFactorAdjustmentsConstants.URL}`, params)
            .pipe(map(response => {
            return response;
        }));
    }
    inheritFactorAdjustments(valuationBlockId) {
        return this.httpClient.post(`${ApiPropertyValuationValuationBlockFactorAdjustmentsConstants.URL}/${valuationBlockId}/InheritFactorAdjustmentsFromRun`, {})
            .pipe(map(response => {
            return response;
        }));
    }
    patchPropertyValuationValuationBlockFactorAdjustment(valuationBlockFactorAdjustment, factorAdjustmentId) {
        return this.httpClient.patch(`${ApiPropertyValuationValuationBlockFactorAdjustmentsConstants.URL}/${factorAdjustmentId}`, valuationBlockFactorAdjustment)
            .pipe(map(response => {
            return response;
        }));
    }
    deletePropertyValuationValuationBlockFactorAdjustment(requestBody) {
        return this.httpClient.post(`${ApiPropertyValuationValuationBlockFactorAdjustmentsConstants.URL}/${ApiPropertyValuationValuationBlockFactorAdjustmentsConstants.FUNCTION_DELETE_MULTIPLE_PROPERTY_VALUATION_BLOCK_FACTOR_ADJUSTMENTS}`, requestBody)
            .pipe(map(response => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
AddValuationBlockFactorAdjustmentsService = __decorate([
    Injectable({
        providedIn: "root"
    })
], AddValuationBlockFactorAdjustmentsService);
export { AddValuationBlockFactorAdjustmentsService };
